import React,{ useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"

const Auth = () => {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading, login } = useAuth()
  const [admin_email_address, setEmail] = useState('')
  const [admin_password, setPassword] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard")
    }
  }, [isAuthenticated, navigate])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    
    try {
      const result = await login({ admin_email_address, admin_password })
      if (result.success) {
        navigate('/dashboard')
      } else {
        alert(`Wrong Credentials: ${result.error}`)
      }
    } catch (error) {
      alert(`Login failed: ${error.message}`)
    } finally {
      setIsSubmitting(false)
    }
  }

        // Show loading while checking authentication
        if (isLoading) {
          return (
            <div className="nk-app-root">
              <div className="nk-main">
                <div className="nk-wrap nk-wrap-nosidebar">
                  <div className="nk-content">
                    <div className="nk-block nk-block-middle nk-auth-body wide-xs">
                      <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Checking authentication...</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }

        return(
            <div className="nk-app-root">
  <div className="nk-main ">
    <div className="nk-wrap nk-wrap-nosidebar">
      <div className="nk-content ">
        <div className="nk-block nk-block-middle nk-auth-body  wide-xs">
          <div className="brand-logo pb-4 text-center">
            <a href="/" className="logo-link" title="Westgate Shopping Mall">
              <img
                className="logo-light logo-img logo-img-lg"
                src="./assets/images/wg_logo.png"
                srcSet="./assets/images/wg_logo.png "
                alt="logo"
              />
              <img
                className="logo-dark logo-img logo-img-lg"
                src="./assets/images/wg_logo.png"
                srcSet="./assets/images/wg_logo.png "
                alt="logo-dark"
              />
            </a>
          </div>
          <div className="card">
            <div className="card-inner card-inner-lg">
              <div className="nk-block-head">
                <div className="nk-block-head-content">
                  <h4 className="nk-block-title">Sign In</h4>
                  <div className="nk-block-des">
                  </div>
                </div>
              </div>
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="form-group">
                  <div className="form-label-group">
                    <label className="form-label" htmlFor="default-01">
                      Email or Username
                    </label>
                  </div>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      value={admin_email_address} onChange={e => setEmail(e.target.value)} 
                      id="default-01"
                      placeholder="Enter your email address or username"
                      autofocus
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-label-group">
                    <label className="form-label" htmlFor="password">
                      Password
                    </label>
                    <a
                      className="link link-primary link-sm"
                      href="reset"
                    >
                      Forgot Password?
                    </a>
                  </div>
                  <div className="form-control-wrap">
                    <a
                      href="#"
                      className="form-icon form-icon-right passcode-switch lg"
                      data-target="password"
                    >
                      <em className="passcode-icon icon-show icon ni ni-eye" />
                      <em className="passcode-icon icon-hide icon ni ni-eye-off" />
                    </a>
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      value={admin_password} onChange={e => setPassword(e.target.value)}
                      id="password"
                      placeholder="Enter your password"
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <button className="btn btn-lg btn-primary btn-block" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Signing in...' : 'Sign in'}
                  </button>
                </div>
              </form>
              
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</div>

        )
    }
export default Auth